// 品牌池名称可能是「中文/英文」，统一显示成「中文（英文）/编码」，如「联想（lenovo）/100110」
export function formatBrandDisplay(name: string, code: string) {
  const trimmed = name.trim()
  const brandName = trimmed.endsWith(`/${code}`)
    ? trimmed.slice(0, -(code.length + 1))
    : trimmed
  const [cn, ...rest] = brandName.split('/')
  const en = rest.join('/').trim()
  return cn.trim() && en
    ? `${cn.trim()}（${en}）/${code}`
    : `${brandName}/${code}`
}
// 品牌池名称可能是「中文/英文」，统一显示成「中文（英文）/编码」，如「联想（lenovo）/100110」
export function formatBrandDisplay(name: string, code: string) {
  const trimmed = name.trim()
  const brandName = trimmed.endsWith(`/${code}`)
    ? trimmed.slice(0, -(code.length + 1))
    : trimmed
  const [cn, ...rest] = brandName.split('/')
  const en = rest.join('/').trim()
  return cn.trim() && en
    ? `${cn.trim()}（${en}）/${code}`
    : `${brandName}/${code}`
}
